'use client';

import { c as _c } from "react/compiler-runtime";
import { ExternalLinkTooltip, Field, FieldContent, FieldDescription, FieldError, FieldLabel, Input, InputGroup, InputGroupAddon, InputGroupButton, InputGroupInput, Spinner } from '@repo/ui/components';
import { Eye, EyeOff } from '@repo/ui/icons';
import { cn } from '@repo/ui/lib/utils';
import { ComponentProps, ReactNode, useState } from 'react';
import { dedupeErrors } from '../lib/dedupe-errors.ts';
import { useFieldContext } from '../lib/form-context.ts';
export const FormPasswordInput = t0 => {
  const $ = _c(73);
  let className;
  let description;
  let href;
  let label;
  let props;
  let required;
  let t1;
  let t2;
  let t3;
  let variant;
  if ($[0] !== t0) {
    ({
      className,
      compact: t1,
      description,
      disabled: t2,
      href,
      isPending: t3,
      label,
      required,
      variant,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = className;
    $[2] = description;
    $[3] = href;
    $[4] = label;
    $[5] = props;
    $[6] = required;
    $[7] = t1;
    $[8] = t2;
    $[9] = t3;
    $[10] = variant;
  } else {
    className = $[1];
    description = $[2];
    href = $[3];
    label = $[4];
    props = $[5];
    required = $[6];
    t1 = $[7];
    t2 = $[8];
    t3 = $[9];
    variant = $[10];
  }
  const compact = t1 === undefined ? false : t1;
  const disabled = t2 === undefined ? false : t2;
  const isPending = t3 === undefined ? false : t3;
  const field = useFieldContext();
  let t4;
  if ($[11] !== field.state.meta.errors) {
    t4 = field.state.meta.errors ?? [];
    $[11] = field.state.meta.errors;
    $[12] = t4;
  } else {
    t4 = $[12];
  }
  let t5;
  if ($[13] !== t4) {
    t5 = dedupeErrors(t4);
    $[13] = t4;
    $[14] = t5;
  } else {
    t5 = $[14];
  }
  const errors = t5;
  const [showPassword, setShowPassword] = useState(false);
  const isDisabled = isPending || disabled;
  const inputId = field.name;
  const toggleId = `${inputId}-toggle`;
  let t6;
  if ($[15] !== className) {
    t6 = cn(className);
    $[15] = className;
    $[16] = t6;
  } else {
    t6 = $[16];
  }
  const t7 = props["data-testid"] ?? field.name;
  let t8;
  if ($[17] !== field) {
    t8 = e => field.handleChange(e.target.value);
    $[17] = field;
    $[18] = t8;
  } else {
    t8 = $[18];
  }
  const t9 = showPassword ? "text" : "password";
  const t10 = field.state.value ?? "";
  let t11;
  if ($[19] !== field.handleBlur || $[20] !== inputId || $[21] !== isDisabled || $[22] !== props || $[23] !== t10 || $[24] !== t6 || $[25] !== t7 || $[26] !== t8 || $[27] !== t9) {
    t11 = <InputGroupInput className={t6} data-testid={t7} disabled={isDisabled} id={inputId} onBlur={field.handleBlur} onChange={t8} type={t9} value={t10} {...props} />;
    $[19] = field.handleBlur;
    $[20] = inputId;
    $[21] = isDisabled;
    $[22] = props;
    $[23] = t10;
    $[24] = t6;
    $[25] = t7;
    $[26] = t8;
    $[27] = t9;
    $[28] = t11;
  } else {
    t11 = $[28];
  }
  let t12;
  if ($[29] !== compact || $[30] !== isPending) {
    t12 = isPending && <InputGroupAddon align="inline-end" className={cn(compact && "py-0")}><Spinner className="text-muted-foreground" /></InputGroupAddon>;
    $[29] = compact;
    $[30] = isPending;
    $[31] = t12;
  } else {
    t12 = $[31];
  }
  const t13 = compact && "py-0";
  let t14;
  if ($[32] !== t13) {
    t14 = cn(t13);
    $[32] = t13;
    $[33] = t14;
  } else {
    t14 = $[33];
  }
  const t15 = showPassword ? "Hide password" : "Show password";
  const t16 = `${props["data-testid"] ?? field.name}-toggle`;
  let t17;
  if ($[34] === Symbol.for("react.memo_cache_sentinel")) {
    t17 = () => setShowPassword(_temp);
    $[34] = t17;
  } else {
    t17 = $[34];
  }
  const t18 = compact ? "icon-xs" : "xs";
  let t19;
  if ($[35] !== showPassword) {
    t19 = showPassword ? <Eye data-icon="eye" /> : <EyeOff data-icon="eye-off" />;
    $[35] = showPassword;
    $[36] = t19;
  } else {
    t19 = $[36];
  }
  let t20;
  if ($[37] !== inputId || $[38] !== isDisabled || $[39] !== showPassword || $[40] !== t15 || $[41] !== t16 || $[42] !== t18 || $[43] !== t19 || $[44] !== toggleId) {
    t20 = <InputGroupButton aria-controls={inputId} aria-label={t15} aria-pressed={showPassword} data-testid={t16} disabled={isDisabled} id={toggleId} onClick={t17} size={t18} type="button">{t19}</InputGroupButton>;
    $[37] = inputId;
    $[38] = isDisabled;
    $[39] = showPassword;
    $[40] = t15;
    $[41] = t16;
    $[42] = t18;
    $[43] = t19;
    $[44] = toggleId;
    $[45] = t20;
  } else {
    t20 = $[45];
  }
  let t21;
  if ($[46] !== t14 || $[47] !== t20) {
    t21 = <InputGroupAddon align="inline-end" className={t14}>{t20}</InputGroupAddon>;
    $[46] = t14;
    $[47] = t20;
    $[48] = t21;
  } else {
    t21 = $[48];
  }
  let t22;
  if ($[49] !== t11 || $[50] !== t12 || $[51] !== t21 || $[52] !== variant) {
    t22 = <InputGroup variant={variant}>{t11}{t12}{t21}</InputGroup>;
    $[49] = t11;
    $[50] = t12;
    $[51] = t21;
    $[52] = variant;
    $[53] = t22;
  } else {
    t22 = $[53];
  }
  const inputElement = t22;
  if (compact) {
    let t23;
    if ($[54] !== errors) {
      t23 = <FieldError className="text-sm" errors={errors} />;
      $[54] = errors;
      $[55] = t23;
    } else {
      t23 = $[55];
    }
    let t24;
    if ($[56] !== inputElement || $[57] !== t23) {
      t24 = <Field className="gap-1">{inputElement}{t23}</Field>;
      $[56] = inputElement;
      $[57] = t23;
      $[58] = t24;
    } else {
      t24 = $[58];
    }
    return t24;
  }
  let t23;
  if ($[59] !== href || $[60] !== inputId || $[61] !== label || $[62] !== required) {
    t23 = label && typeof label === "string" ? <FieldLabel className={cn(required && "required gap-0.5")} htmlFor={inputId}>{label} {href && <ExternalLinkTooltip href={href} />}</FieldLabel> : label;
    $[59] = href;
    $[60] = inputId;
    $[61] = label;
    $[62] = required;
    $[63] = t23;
  } else {
    t23 = $[63];
  }
  let t24;
  if ($[64] !== description) {
    t24 = description && typeof description === "string" ? <FieldDescription>{description}</FieldDescription> : description;
    $[64] = description;
    $[65] = t24;
  } else {
    t24 = $[65];
  }
  let t25;
  if ($[66] !== errors) {
    t25 = <FieldError className="text-sm" errors={errors} data-sentry-element="FieldError" data-sentry-source-file="form-password-input.tsx" />;
    $[66] = errors;
    $[67] = t25;
  } else {
    t25 = $[67];
  }
  let t26;
  if ($[68] !== inputElement || $[69] !== t23 || $[70] !== t24 || $[71] !== t25) {
    t26 = <Field className="group gap-1" data-sentry-element="Field" data-sentry-component="FormPasswordInput" data-sentry-source-file="form-password-input.tsx"><FieldContent data-sentry-element="FieldContent" data-sentry-source-file="form-password-input.tsx">{t23}{inputElement}{t24}{t25}</FieldContent></Field>;
    $[68] = inputElement;
    $[69] = t23;
    $[70] = t24;
    $[71] = t25;
    $[72] = t26;
  } else {
    t26 = $[72];
  }
  return t26;
};
function _temp(prev) {
  return !prev;
}